exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".nav-link[data-toggle].collapsed:after {\n    content: \"\\25BE\";\n}\n.nav-link[data-toggle]:not(.collapsed):after {\n    content: \"\\25B4\";\n}\n\n.submenu {\n    margin-bottom:10px;\n    list-style-position: initial;\n    list-style-type: disc;\n}\n\n@media (min-width: 48em) {\n        img.logo {\n\t\t  max-width: 200px;\n\t   }\n}\n\n// Large devices (desktops, 62em and up)\n@media (min-width: 62em) {\n\timg.logo {\n\t\tmax-width: 200px;\n\t}\n}\n\n@media (max-width: 24em) {\n        img.logo {\n\t\t  max-width: 120px;\n            padding-bottom: 10px\n\t   }\n}\n\n\n.dropdown:hover>.dropdown-menu {\n  display: block;\n}\n.dropdown-menu {\n    min-width: 20rem !important;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/globant/site/src/app/components/ui/top-nav/top-nav.component.css
// module id = ../../../../../src/app/components/ui/top-nav/top-nav.component.css
// module chunks = main